/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { Container, Form, Button, Spinner } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useAppDispatch } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import CheckboxInput from 'components/input/CheckboxInput';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { updateHousehold } from 'app/family/familySlice';
import {
  BoolToString,
  checkEnableParseJSON,
  formatBoolean,
  optionValues,
  tryParseJSON,
} from 'components/helper/helper';
import LoadingContent from 'components/LoadingContent';
import { HtmlTooltip } from 'screen/selectCollege/SelecCollegePage';
import { Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GroupRadioButton from 'components/input/GroupRadioButton';
import { debounce } from 'lodash';
import { getDemoGraphics } from 'app/basicInformationSlice/basicInformationSlice';
import familyServices from 'services/familyServices';
import basicInformationServices from 'services/basicInformationApi';
import Grid from '@mui/joy/Grid';
// import { ModalCheckField } from 'screen/common/ModalCheckField';
import { ModalCheckFamilyField } from '../common/ModalCheckMissingField';
import SearchIcon from '@mui/icons-material/Search';
import pageStatusService from 'services/pageStatusService';
import { PAGE_NAME } from 'constants/common';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import {
  GM_PERMANENT_HOME_OPTIONS,
  PERMANENT_HOME_OTHER_MAX,
  isLegalGuardianHome,
  normalizePermanentHome,
} from './permanentHome';

export const householdSize = [
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 4 },
  { value: 5 },
  { value: 6 },
  { value: 7 },
  { value: 8 },
  { value: 9 },
  { value: 10 },
  { value: 11 },
  { value: 12 },
  { value: 13 },
  { value: 14 },
  { value: 15 },
  { value: 16 },
  { value: 17 },
  { value: 18 },
  { value: 19 },
  { value: 20 },
];

interface Props {}
export const householdOptions = [
  { value: 'Parents(s)/Guardian(s)', key: 'is_parent_guardian' },
  { value: 'Sibling(s)', key: 'is_sibbling' },
  { value: 'Spouse', key: 'is_spouse' },
  { value: 'Child(ren)', key: 'is_child' },
  { value: 'Other', key: 'is_other' },
  { value: 'Just me', key: 'is_just_me' },
];

interface RoleFamily {
  parentNo1: boolean;
  parentNo2: boolean;
  legalGuardian: boolean;
  stepParent1: boolean;
  stepParent2: boolean;
  siblings: boolean;
}

const Household = (props: Props) => {
  const [demographics, setDemographics] = React.useState<any>(null);
  const [roleFamily, setRoleFamily] = React.useState<RoleFamily | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [showModalCheckField, setShowModalCheckField] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  const formHousehold = useFormik({
    initialValues: {
      describe_other_family_members: '',
      is_parent_guardian: false,
      is_sibbling: false,
      is_spouse: false,
      is_child: false,
      is_just_me: false,
      is_other: false,
    },
    onSubmit: () => {},
  });
  const dispatch:any = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();

  const formik = useFormik({
    initialValues: {
      is_listing_step_parents: '',
      how_many_step_parents: '',
      who_in_household_array: '',
      household_size: 0,
      whom_live_permanently: '',
      parent_martial_status: '',
      household_income: 0,
      is_have_any_children: '',
      highest_level_education_parent: '',
      bachelor_level_education_parent: false,
      how_many_children: 0,
      other_live_with_free_text: '',
      year_of_divorce: undefined,
      other_parent_martial_status: '',
      legal_guardian: '',
      csu_info: {
        household_income_information_statements: '', // One or more of the above statements apply to me: Independent, None of the above statements apply to me: Dependent status
        parent_gross_income: '',
        parent_untaxed_income: '',
        gross_income: '',
        untaxed_income: '',
        parent_1_highest_level_education: 'Select',
        parent_2_highest_level_education: 'Select',
        parent_graduate_within_the_last_five_years: '',
        people_were_supported_by_this_income: '',
        parent_1_highest_level_education_last_five_years: '',
        parent_2_highest_level_education_last_five_years: '',
        highest_level_education_parent_last_five_years: '',
      },
    },
    onSubmit: async (values) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        try {
          setSaving(true);
          const newValues = {
            ...values,
            csu_info: JSON.stringify(values.csu_info),
            who_in_household_array: JSON.stringify(formHousehold.values),
            is_have_any_children: formatBoolean(values.is_have_any_children),
            legal_guardian: JSON.stringify(formLegalGuardian.values),
            ...normalizePermanentHome(
              values.whom_live_permanently,
              values.other_live_with_free_text
            ),
            student_id: parseInt(studentId || ''),
          };
          await dispatch(updateHousehold(newValues));

          await getDemoGraphics(studentId);
        } catch (ex) {
          console.log('Error: ', ex);
        }
        setSaving(false);
      } else {
        handleLogout();
      }
    },
  });
  const formLegalGuardian = useFormik({
    initialValues: {
      step_parent_is_married: '',
      step_parent_type: '',
      step_parent_is_living: '',
      prefix: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      former_last_name: '',
      suffix: '',
      step_parent_relationship: '',
      step_parent_email: '',
      country_code: '',
      phone_number: '',
      phone_number_type: '',
      occupation: '',
      other_occupation_detail: '',
      employment_status: '',
      currently_employed_or_retire_from_college: '',
      college_or_university: '',
      current_employer: '',
      education_level: '',
      total_number_institutions_attended: '',
      parent_graduation_college_array: '',
    },
    onSubmit: () => {},
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    if (roleFamily) {
      const nextRoute = Object.keys(roleFamily).find(
        (key) => roleFamily[key as keyof RoleFamily] === true
      );
      history.push(nextRoute ? routers?.[nextRoute]?.path : routers.enrolimentStatus.path);
    }
  };

  const handleCheckMissingFields = () => {
    setShowModalCheckField(true);
  };

  const handleCloseModal = () => {
    setShowModalCheckField(false);
  };

  // Prepare data for modal check
  const getModalData = () => {
    return {
      ...formik.values,
      who_in_household_array: formHousehold.values,
      legal_guardian: formLegalGuardian.values,
    };
  };

  const buildRole = (myHousehold: any) => {
    const who_in_household_array = checkEnableParseJSON(myHousehold?.who_in_household_array, {});
    let role = {
      parentNo1: false,
      parentNo2: false,
      legalGuardian: false,
      stepParent1: false,
      stepParent2: false,
      siblings: false,
    };
    if (who_in_household_array?.is_parent_guardian) {
      role.parentNo1 = true;
      role.parentNo2 = true;
    }
    if (who_in_household_array?.is_sibbling) {
      role.siblings = true;
    }

    if (
      myHousehold?.is_listing_step_parents === 'true' &&
      myHousehold?.how_many_step_parents === '1'
    ) {
      role.stepParent1 = true;
    } else if (myHousehold?.is_listing_step_parents === 'true') {
      role.stepParent1 = true;
      role.stepParent2 = true;
    }
    if (isLegalGuardianHome(myHousehold?.whom_live_permanently)) {
      role.legalGuardian = true;
    }

    return role;
  };

  const getDemoragphic = async (studentId: any) => {
    const res = await basicInformationServices.getDemoGraphics(studentId);
    setDemographics(res);
  };
  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.HOUSEHOLD);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      let dataLoaded: any = await familyServices.getHousehold(studentId);
      if (dataLoaded) {
        const values: any = {
          ...formik.values,
          ...dataLoaded,
          csu_info: { ...formik.values.csu_info, ...checkEnableParseJSON(dataLoaded.csu_info) },
          is_have_any_children: BoolToString(dataLoaded.is_have_any_children),
          ...normalizePermanentHome(
            dataLoaded.whom_live_permanently,
            dataLoaded.other_live_with_free_text
          ),
        };

        let who_in_household_array = tryParseJSON(dataLoaded.who_in_household_array);
        let legal_guardian = tryParseJSON(dataLoaded?.legal_guardian);

        formHousehold.setValues({
          ...formHousehold.values,
          ...who_in_household_array,
        });
        formLegalGuardian.setValues(legal_guardian);
        formik.setValues(values);

        setRoleFamily(buildRole(values));
        await getDemoragphic(studentId);
      }

      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };
  React.useEffect(() => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      getDetail();
      dispatch(getDemoGraphics(studentId));
    } else {
      handleLogout();
    }
  }, []);
  React.useEffect(() => {
    if (formHousehold.values.is_just_me) {
      formHousehold.setValues({
        ...formHousehold.values,
        is_parent_guardian: false,
        is_sibbling: false,
        is_spouse: false,
        is_child: false,
        is_other: false,
      });
    }
  }, [formHousehold.values.is_just_me]);
  React.useEffect(() => {
    if (
      formHousehold.values.is_parent_guardian === true ||
      formHousehold.values.is_sibbling === true ||
      formHousehold.values.is_spouse === true ||
      formHousehold.values.is_child === true ||
      formHousehold.values.is_other === true
    ) {
      formHousehold.setFieldValue('is_just_me', false);
      return;
    }
  }, [
    formHousehold.values.is_parent_guardian,
    formHousehold.values.is_sibbling,
    formHousehold.values.is_spouse,
    formHousehold.values.is_child,
    formHousehold.values.is_other,
  ]);

  // Add new useEffect to watch formHousehold.values changes
  React.useEffect(() => {
    const newRoleFamily = buildRole({
      who_in_household_array: JSON.stringify(formHousehold.values),
      is_listing_step_parents: formik.values.is_listing_step_parents,
      how_many_step_parents: formik.values.how_many_step_parents,
      whom_live_permanently: formik.values.whom_live_permanently,
    });
    setRoleFamily(newRoleFamily);
  }, [
    formHousehold.values,
    formik.values.is_listing_step_parents,
    formik.values.how_many_step_parents,
    formik.values.whom_live_permanently,
  ]);

  React.useEffect(() => {
    debounceSaving();
  }, [formik.values, formHousehold.values, formLegalGuardian.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );
  // Auto save function ==========

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.HOUSEHOLD, reviewedAndComplete, setReviewedAndComplete);
  }
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { title: 'General', percentOnProcess: 30 },
          {
            title: 'Parental Marital Status',
            percentOnProcess: 45,
            specialId: 'ParentalMaritalStatus',
          },
          { title: 'Household Income', percentOnProcess: 70 },
          { title: 'Dependents', percentOnProcess: 88 },
        ]}
        title="Family Information"
        process={1}
        icon={<PeopleAltOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div id="General" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Household
              </span>
            </div>
            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div className="text-dart fs-5">Household Income and Size Information</div>
                  <div className="text-dart mt-4">
                    Please review the following statements carefully to determine if any of them
                    apply to you. Then, answer the question below.
                  </div>
                  <ul>
                    <li className="text-mute m-1 ms-3">You were born before January 1, 2004.</li>
                    <li className="text-mute m-1 ms-3">
                      You are currently an active-duty member or a veteran of the U.S. Armed Forces.
                    </li>
                    <li className="text-mute m-1 ms-3">
                      As of today, you are married or you are separated, but not divorced.
                    </li>
                    <li className="text-mute m-1 ms-3">
                      You have or will have children or dependents who will receive more than half
                      of their support from you between July 1, 2027, and June 30, 2028.
                    </li>
                    <li className="text-mute m-1 ms-3">
                      Someone other than your parent(s) or stepparent(s) has legal guardianship of
                      you, as determined by a court in your state of legal residence.
                    </li>
                    <li className="text-mute m-1 ms-3">
                      At any time since you turned age 13, both your parents were deceased, you were
                      in foster care, or you were a dependent or ward of the court.
                    </li>
                    <li className="text-mute m-1 ms-3">
                      At any time on or after July 1, 2026, your high school, an emergency shelter,
                      a transitional housing program, or a homeless youth center determined you were
                      an unaccompanied youth or were self-supporting and at risk of being homeless.
                    </li>
                    <li className="text-mute m-1 ms-3">
                      You currently do not live with your parent(s)/stepparent(s) and have not had
                      contact and no financial support from them for the last 12 months or more.
                    </li>
                  </ul>
                </Grid>

                <Grid xs={12}>
                  <GroupRadioButton
                    mdCol={12}
                    verticalLayout={true}
                    dataUp="hh-income-statements"
                    options={[
                      'None of the above statements apply to me',
                      'One or more of the above statements apply to me',
                    ]}
                    onChange={formik.handleChange}
                    name="csu_info.household_income_information_statements"
                    values={formik.values.csu_info?.household_income_information_statements}
                    label="Do any of the above statements apply to you?*"
                    isMissing={
                      !formik.values.csu_info?.household_income_information_statements && check
                    }
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <div
                    style={{
                      display: 'inline-block',
                      background:
                        formHousehold.values &&
                        check &&
                        !Object.values(formHousehold.values).some((item: any) => item === true)
                          ? '#FFEBEB'
                          : '',
                    }}
                  >
                    Who is in your household? (select all that apply)*
                  </div>
                </Grid>

                {householdOptions.map((option, index) => {
                  const key = option.key;
                  const formValues: any = formHousehold.values;

                  return (
                    <Grid xs={12} md={4} lg={3} key={index}>
                      <CheckboxInput
                        label={<span className="text-field-light">{option.value}</span>}
                        name={key}
                        values={formValues[key]}
                        onChange={(e) => formHousehold.setFieldValue(key, e.target.checked)}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                  );
                })}

                {formHousehold.values.is_other === true && (
                  <>
                    <Grid xs={12}>
                      <div className="text-dart mt-3">
                        If there are other family members who live with you, please tell us who they
                        are. For example: A grandparent or other relative.
                      </div>
                    </Grid>
                    <Grid xs={12}>
                      <TextInput
                        logo="span-csu-logo"
                        label="Describe other family members*"
                        countText={50}
                        name="describe_other_family_members"
                        values={formHousehold.values.describe_other_family_members}
                        onChange={formHousehold.handleChange}
                        isMissing={
                          formHousehold.values.is_other &&
                          !formHousehold.values.describe_other_family_members &&
                          check
                        }
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                  </>
                )}

                {![
                  formHousehold.values.is_parent_guardian,
                  formHousehold.values.is_sibbling,
                  formHousehold.values.is_spouse,
                  formHousehold.values.is_child,
                ].every((i) => i === false) && (
                  <Grid xs={12}>
                    <SelectInput
                      className="uc-coallition-flag mt-3"
                      form={formik}
                      option={householdSize}
                      label="Household Size *"
                      dataUp="hh-household-size"
                      name="household_size"
                      values={formik.values.household_size}
                      onChange={formik.handleChange}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}

              {formHousehold.values.is_parent_guardian && (
                <>
                <Grid xs={12}></Grid>
                  <Grid xs={12}
                      md={
                        formik.values.highest_level_education_parent ==='2-year college graduate' || 
                        formik.values.highest_level_education_parent ==='4-year college graduate'
                          ? 6 : 12
                      }
                  >
                    <SelectInput
                      id={`highest_level_education_parent`}
                      logo={
                        formik.values.highest_level_education_parent ==='2-year college graduate' || 
                        formik.values.highest_level_education_parent ==='4-year college graduate'
                        ? "span-uc-logo logo-absolute-0": "span-uc-logo"
                      }
                      form={formik}
                      option={[
                        'Select',
                        'No High School',
                        'Some High School',
                        'High School Graduate',
                        'Some College',
                        '2-year college graduate',
                        '4-year college graduate',
                        'Postgraduate',
                        'Does not apply',
                      ]}
                      label="What is the highest level of education earned by any of your parents?*"
                      name="highest_level_education_parent"
                      values={formik.values.highest_level_education_parent}
                      onChange={formik.handleChange}
                      isMissing={
                        (!formik.values.highest_level_education_parent ||
                          formik.values.highest_level_education_parent === 'Select') &&
                        check
                      }
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                  {(formik.values.highest_level_education_parent === '2-year college graduate' ||
                    formik.values.highest_level_education_parent === '4-year college graduate') && (
                      <Grid xs={12} md={6} className="custom ps-md-4">
                        <YesNoSwitch
                          className="label-mb-1"
                          label="Did this parent graduate within the last five years?*"
                          name="csu_info.highest_level_education_parent_last_five_years"
                          values={
                            formik.values.csu_info?.highest_level_education_parent_last_five_years
                          }
                          onChange={formik.handleChange}
                          isMissing={!formik.values.csu_info?.highest_level_education_parent_last_five_years && check}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>
                  )}

                <Grid
                  xs={12}
                  md={
                    formik.values.csu_info?.parent_1_highest_level_education ==='2-year college graduate' || 
                    formik.values.csu_info?.parent_1_highest_level_education ==='4-year college graduate'
                      ? 6 : 12
                  }
                >
                  <SelectInput
                    id={`parent_1_highest_level_education`}
                    logo="span-csu-logo logo-absolute-0"
                    form={formik}
                    option={[
                      'Select',
                      'No High School',
                      'Some High School',
                      'High School Graduate',
                      'Some College',
                      '2-year college graduate',
                      '4-year college graduate',
                      'Postgraduate',
                      'Does not apply',
                    ]}
                    label="What is your Parent/Guardian #1 highest level of education?"
                    isLongLableText={true}
                    name="csu_info.parent_1_highest_level_education"
                    values={formik.values.csu_info?.parent_1_highest_level_education}
                    onChange={formik.handleChange}
                    isMissing={
                      (!formik.values.csu_info?.parent_1_highest_level_education ||
                        formik.values.csu_info?.parent_1_highest_level_education === 'Select') &&
                      check
                    }
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                {(formik.values.csu_info?.parent_1_highest_level_education ==='2-year college graduate' ||
                  formik.values.csu_info?.parent_1_highest_level_education ==='4-year college graduate') && (
                  <Grid xs={12} md={6} className="custom ps-md-4">
                    <YesNoSwitch
                      className="label-mb-1"
                      label="Did this parent graduate within the last five years?*"
                      name="csu_info.parent_1_highest_level_education_last_five_years"
                      values={formik.values.csu_info?.parent_1_highest_level_education_last_five_years}
                      onChange={formik.handleChange}
                      isMissing={!formik.values.csu_info?.parent_1_highest_level_education_last_five_years && check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}

                <Grid
                  xs={12}
                  md={
                    formik.values.csu_info?.parent_2_highest_level_education ==='2-year college graduate' ||
                    formik.values.csu_info?.parent_2_highest_level_education ==='4-year college graduate'
                      ? 6: 12
                  }
                >
                  <SelectInput
                    id={`parent_2_highest_level_education`}
                    logo={
                      formik.values.csu_info?.parent_2_highest_level_education ==='2-year college graduate' ||
                      formik.values.csu_info?.parent_2_highest_level_education ==='4-year college graduate'
                      ? "span-csu-logo logo-absolute-0" : "span-csu-logo"
                    }
                    form={formik}
                    option={[
                      'Select',
                      'No High School',
                      'Some High School',
                      'High School Graduate',
                      'Some College',
                      '2-year college graduate',
                      '4-year college graduate',
                      'Postgraduate',
                      'Does not apply',
                    ]}
                    label="What is your Parent/Guardian #2 highest level of education?*"
                    isLongLableText={true}
                    name="csu_info.parent_2_highest_level_education"
                    values={formik.values.csu_info?.parent_2_highest_level_education}
                    onChange={formik.handleChange}
                    isMissing={
                      (!formik.values.csu_info?.parent_2_highest_level_education ||
                        formik.values.csu_info?.parent_2_highest_level_education === 'Select') &&
                      check
                    }
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                {(formik.values.csu_info?.parent_2_highest_level_education ==='2-year college graduate' ||
                  formik.values.csu_info?.parent_2_highest_level_education ==='4-year college graduate') && (
                  <Grid xs={12} md={6} className="custom ps-md-4">
                    <YesNoSwitch
                      className="label-mb-1"
                      label="Did this parent graduate within the last five years?"
                      name="csu_info.parent_2_highest_level_education_last_five_years"
                      values={
                        formik.values.csu_info?.parent_2_highest_level_education_last_five_years
                      }
                      onChange={formik.handleChange}
                      isMissing={
                        !formik.values.csu_info?.parent_2_highest_level_education_last_five_years &&
                        check
                      }
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}
                </>
              )}
              </Grid>
            </div>

            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="ParentalMaritalStatus" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Parental Marital Status
                    </span>
                  </div>
                </Grid>

                <Grid xs={12}>
                  <SelectInput
                    logo="span-cm-logo"
                    form={formik}
                    option={[
                      { value: 'Married' },
                      { value: 'Separated' },
                      { value: 'Divorced' },
                      { value: 'Never Married' },
                      { value: 'Widowed' },
                      { value: 'Civil Union/Domestic Partners' },
                    ]}
                    label="Parents'/Guardians' Marital Status (relative to each other) *"
                    // setLabelHight={true}
                    name="parent_martial_status"
                    values={formik.values.parent_martial_status}
                    onChange={(e) => {
                      formik.handleChange(e);
                      if (!['Divorced', 'Never Married', 'Widowed'].includes(e.target.value)) {
                        formik.setFieldValue('is_listing_step_parents', 'false');
                      }
                    }}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                {formik.values.parent_martial_status === 'Divorced' && (
                  <Grid xs={12}>
                    <SelectInput
                      className="common-coallition-flag"
                      form={formik}
                      option={optionValues(
                        Array.from(
                          { length: new Date().getFullYear() + 1 - 1950 + 1 },
                          (_, i) => i + 1950
                        )
                      )?.reverse()}
                      label="Year of divorce*"
                      name="year_of_divorce"
                      values={formik.values.year_of_divorce}
                      onChange={formik.handleChange}
                      isMissing={!formik.values.year_of_divorce && check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}

                <Grid xs={12}>
                  <SelectInput
                    logo="span-uc-logo span-cm-logo"
                    form={formik}
                    option={GM_PERMANENT_HOME_OPTIONS.map((value) => ({ value }))}
                    label="With whom do you make your permanent home?*"
                    name="whom_live_permanently"
                    values={formik.values.whom_live_permanently}
                    onChange={(e) => {
                      formik.handleChange(e);
                      const next = normalizePermanentHome(
                        e.target.value,
                        formik.values.other_live_with_free_text
                      );
                      formik.setFieldValue(
                        'other_live_with_free_text',
                        next.other_live_with_free_text
                      );
                      if (!isLegalGuardianHome(e.target.value)) {
                        formik.setFieldValue('is_listing_step_parents', 'false');
                      }
                    }}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                {formik.values.whom_live_permanently === 'Other' && (
                  <Grid xs={12}>
                    <TextInput
                      label="Other*"
                      countText={PERMANENT_HOME_OTHER_MAX}
                      name="other_live_with_free_text"
                      values={formik.values.other_live_with_free_text}
                      onChange={formik.handleChange}
                      isMissing={!formik.values.other_live_with_free_text && check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}

                {['Divorced', 'Never Married', 'Widowed', 'Separated'].includes(
                  formik.values.parent_martial_status
                ) && (
                  <>
                    <Grid xs={12} md={6}>
                      <YesNoSwitch
                        logo="span-cm-logo"
                        label="Do you wish to list any step-parents?*"
                        name="is_listing_step_parents"
                        values={formik.values.is_listing_step_parents}
                        onChange={formik.handleChange}
                        isMissing={!formik.values.is_listing_step_parents && check}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                    {formik.values.is_listing_step_parents === 'true' && (
                      <Grid xs={12} md={6}>
                        <GroupRadioButton
                          columns={3}
                          logo="span-cm-logo"
                          values={formik.values.how_many_step_parents}
                          onChange={formik.handleChange}
                          name="how_many_step_parents"
                          label="How many?*"
                          options={['1', '2']}
                          isMissing={!formik.values.how_many_step_parents && check}
                          mdCol={6}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>
                    )}
                  </>
                )}

                {formik.values.parent_martial_status === 'Other' && (
                  <Grid xs={12}>
                    <TextInput
                      label="Please specify *"
                      name="other_parent_martial_status"
                      values={formik.values.other_parent_martial_status}
                      onChange={formik.handleChange}
                      countText={81}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}
              </Grid>
            </div>
            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="HouseholdIncome" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Household Income
                    </span>
                  </div>
                </Grid>

                <Grid xs={12} md={6}>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography className="fs-6 text-dark my-2 fw-bold">
                          <InfoOutlinedIcon fontSize="small" className="mx-1" />
                          Household Income
                        </Typography>
                        <div className="d-flex flex-wrap text-field-light">
                          Not all colleges ask about this information and other make it optional. In
                          any case, you'll want to chat with your parents about this information. To
                          be prepared - Ask you parents what their annual adjusted gross income and
                          untaxed income is. Some schools will ask for both or just one
                        </div>
                      </React.Fragment>
                    }
                    placement="right-start"
                  >
                    <div>
                      <TextInput
                        logo="span-uc-logo"
                        type="number"
                        label={
                          checkEnableParseJSON(demographics?.all_apply_array)
                            ?.is_none_above_apply_to_me
                            ? 'What was the total income earned in 2025 by your parents or legal guardians?*'
                            : "What was your total income earned in 2025? (Include your spouse's income, if relevant)"
                        }
                        name="household_income"
                        values={formik.values.household_income}
                        onChange={formik.handleChange}
                        setLabelHight={true}
                        isMissing={!formik.values.household_income && check}
                        disabled={reviewedAndComplete}
                      />
                    </div>
                  </HtmlTooltip>
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    decimalStep={1}
                    type="number"
                    min={0}
                    max={9999}
                    label="How many people were supported by this income?"
                    name="csu_info.people_were_supported_by_this_income"
                    values={formik.values.csu_info?.people_were_supported_by_this_income}
                    onChange={formik.handleChange}
                    setLabelHight={true}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                {formik.values.csu_info?.household_income_information_statements ===
                'None of the above statements apply to me' ? (
                  <>
                    <Grid xs={12} md={6}>
                      <TextInput
                        type="number"
                        label={
                          formHousehold.values.is_just_me
                            ? 'Adjusted gross income (AGI) for 2025, all income reported on your federal tax return:*'
                            : "Parents' adjusted gross income (AGI) for 2025. This is the income reported on your parent(s) federal tax return:*"
                        }
                        name="csu_info.parent_gross_income"
                        values={formik.values.csu_info?.parent_gross_income}
                        onChange={formik.handleChange}
                        isMissing={!formik.values.csu_info?.parent_gross_income && check}
                        logo="span-csu-logo"
                        setLabelHight={true}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid xs={12} md={6}>
                      <TextInput
                        type="number"
                        decimalStep={1}
                        label="Adjusted gross income (AGI) for 2025, all income reported on your federal tax return:*"
                        name="csu_info.gross_income"
                        values={formik.values.csu_info?.gross_income}
                        onChange={formik.handleChange}
                        isMissing={!formik.values.csu_info?.gross_income && check}
                        logo="span-csu-logo"
                        setLabelHight={true}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </div>
            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Dependents" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Dependents
                    </span>
                  </div>
                </Grid>

                <Grid xs={12} md={6}>
                  <YesNoSwitch
                    label="Do you have any children ?*"
                    name="is_have_any_children"
                    values={formik.values.is_have_any_children}
                    onChange={formik.handleChange}
                    isMissing={!formik.values.is_have_any_children && check}
                    className="mb-3"
                    disabled={reviewedAndComplete}
                  />
                  {formik.values.is_have_any_children === 'true' && (
                    <Grid xs={12}>
                      <TextInput
                        type="number"
                        max={100}
                        mdCol={'12'}
                        label="How many ?*"
                        name="how_many_children"
                        onChange={formik.handleChange}
                        values={formik.values.how_many_children}
                        isMissing={!formik.values.how_many_children && check}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </div>

            <div className={`gm-form-actions border-top ${isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}>
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {saving ? <Spinner size="sm" animation="border" variant="light" /> : 'Save'}
                  </Button>
                  <Button
                    variant="primary"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <style scoped>{`
#highest_level_education_parent-label,
#parent_1_highest_level_education-label,
#parent_2_highest_level_education-label {
    width: calc(100% - 45px)!important;
    display: inline-block;
}

@media only screen 
and (width: 428px) and (height: 926px) 
and (orientation: landscape) { 
  #highest_level_education_parent-label, #parent_1_highest_level_education-label, #parent_2_highest_level_education-label {
      width: 100%!important;
      display: inline-block;
  }
}
@media only screen 
and (height: 430px) and (width: 932px) {
  #highest_level_education_parent-label, #parent_1_highest_level_education-label, #parent_2_highest_level_education-label {
      width: 100%!important;
      display: inline-block;
  }
}
@media only screen 
    and (height: 412px) and (width: 914px) { 
    #highest_level_education_parent-label, #parent_1_highest_level_education-label, #parent_2_highest_level_education-label {
      width: calc(100% - 30px)!important;
      display: inline-block;
   }
}
@media only screen 
    and (height: 768px) and (width: 1024px) { 
    #highest_level_education_parent-label, #parent_1_highest_level_education-label, #parent_2_highest_level_education-label {
      width: calc(100% - 35px)!important;
      display: inline-block;
   }
}
@media only screen 
    and (height: 1368px) and (width: 912px) { 
    #highest_level_education_parent-label, #parent_1_highest_level_education-label, #parent_2_highest_level_education-label {
      width: calc(100% - 35px)!important;
      display: inline-block;
   }
}
@media only screen 
    and (height: 390px) and (width: 844px) { 
    #highest_level_education_parent-label, #parent_1_highest_level_education-label, #parent_2_highest_level_education-label {
      width: calc(100% - 35px)!important;
      display: inline-block;
   }
}

        `}
        </style>
      </Container>

      <ModalCheckFamilyField
        show={showModalCheckField}
        onClose={handleCloseModal}
        data={getModalData()}
        page="household"
      />
    </>
  );
};

export default Household;
